<template>
  <vx-card class="overflow-hidden">
    <template slot="no-body">
      <div class="vessel-picture-area">
        <img v-if="pictureUrl" class="vessel-picture-img" :src="pictureUrl" />
        <div v-else class="vessel-picture-bg" />
        <p v-show="!pictureUrl">{{ pictureText }}</p>
      </div>
    </template>
  </vx-card>
</template>

<script>
import { storage } from "@/firebase/firebaseConfig";

export default {
  components: {},
  props: {
    picture: { type: Object, default: null }
  },
  data() {
    return {
      pictureUrl: null
    };
  },
  watch: {
    picture: {
      immediate: true,
      async handler() {
        if (this.picture.id !== "0") {
          this.setPictureUrl();
        }
      }
    }
  },
  computed: {
    pictureText() {
      if (this.picture.id !== "0") {
        return "取得中...";
      } else {
        return "No image";
      }
    }
  },
  methods: {
    setPictureUrl() {
      storage
        .child(this.picture.thumbnail_path)
        .getDownloadURL()
        .then(response => {
          this.pictureUrl = response;
        });
    }
  },
  created() {}
};
</script>

<style lang="scss">
.vessel-picture-area {
  position: relative;
}

.vessel-picture-area p {
  position: absolute;
  top: 50%;
  left: 50%;
  color: white;
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  margin: 0;
  padding: 0;
}

.vessel-picture-area img {
  width: 100%;
}

.vessel-picture-bg {
  width: 100%;
  height: 140px;
  background: black;
}
</style>
